const agent = {
  AFREECATV_APP_AGENT: 'Afreeca API',
  AFREECATV_WEBVIEW_AGENT: 'Afreeca Webview',
  SOOPLIVE_APP_AGENT: 'Sooplive API',
  SOOPLIVE_WEBVIEW_AGENT: 'Sooplive Webview'
};

const cookie = {
  TICKET_COOKIE_NAME: 'AuthTicket',
  BBS_COOKIE_NAME: 'BbsTicket',
  USER_COOKIE_NAME: 'UserTicket',
  SAVETICKET_COOKIE_NAME: 'BbsSaveTicket',
  ADULTCHECK_COOKIE_NAME: 'AdultCheckedPass'
};

var NodeEnvType;
(function (NodeEnvType) {
  NodeEnvType["TEST"] = "test";
  NodeEnvType["DEVELOPMENT"] = "development";
  NodeEnvType["BETA"] = "beta";
  NodeEnvType["STAGING"] = "staging";
  NodeEnvType["PRODUCTION"] = "production";
})(NodeEnvType || (NodeEnvType = {}));
const hostGenerator = ({
  environment,
  currentProtocol = 'https:',
  hostname = ''
}) => {
  switch (environment) {
    case NodeEnvType.DEVELOPMENT:
    case NodeEnvType.BETA:
    case NodeEnvType.STAGING:
    case NodeEnvType.TEST:
      return developmentDomain(currentProtocol, hostname);
    case NodeEnvType.PRODUCTION:
      return productionDomain(currentProtocol, hostname);
  }
};
const commonDomains = (protocol, hostname) => {
  const AFREECA_ROOT_DOMAIN = 'afreeca.com';
  const AFREECATV_ROOT_DOMAIN = 'afreecatv.com'; //아프리카TV 1차 도메인 (rewrite 로직에서 사용될, 호출 도메인에 따라 값이 변경되면 안되는 항목임)
  const SOOPLIVE_ROOT_DOMAIN = 'sooplive.co.kr'; //SOOP 1차 도메인 (rewrite 로직에서 사용될, 호출 도메인에 따라 값이 변경되면 안되는 항목)
  const SERVICE_ROOT_DOMAIN = 'sooplive.co.kr'; //서비스 최상위 도메인 (호출 주소에 따라 달라지지 않는, 서비스 고정
  // const DOMAIN_CHECK_REGEX = /([a-z0-9\-_]+)*\.[a-z]{2,6}$/;
  const DOMAIN_CHECK_REGEX = /([a-z0-9\-_]+)*\.[a-z]{2,6}$/;
  let DOMAIN = SERVICE_ROOT_DOMAIN;
  if (DOMAIN_CHECK_REGEX.test(hostname)) {
    const DOMAIN_CHECK_RESULT = hostname.match(DOMAIN_CHECK_REGEX);
    if (DOMAIN_CHECK_RESULT?.[0] === AFREECATV_ROOT_DOMAIN || DOMAIN_CHECK_RESULT?.[0] === 'ext-' + AFREECATV_ROOT_DOMAIN) {
      DOMAIN = AFREECATV_ROOT_DOMAIN;
    } else if (DOMAIN_CHECK_RESULT?.[0] === AFREECA_ROOT_DOMAIN) {
      DOMAIN = AFREECA_ROOT_DOMAIN;
    }
  }
  return {
    DOMAIN,
    AFREECATV_ROOT_DOMAIN,
    SOOPLIVE_ROOT_DOMAIN,
    SERVICE_ROOT_DOMAIN,
    /**
     * 신규 도메인 정리하는 부분(아래부분부터)
     */
    RES_AFREECATV: `${protocol}//res.${SERVICE_ROOT_DOMAIN}`,
    STATIC_AFREECATV: `${protocol}//static.${SERVICE_ROOT_DOMAIN}`,
    LIVEIMG_AFREECATV: `${protocol}//liveimg.${SERVICE_ROOT_DOMAIN}`,
    ADMIN_IMG_AFREECATV: `${protocol}//admin.img.${SERVICE_ROOT_DOMAIN}`,
    STATIC_FILE_AFREECATV: `${protocol}//static.file.${SERVICE_ROOT_DOMAIN}`,
    STIMG_AFREECATV: `${protocol}//stimg.${SERVICE_ROOT_DOMAIN}`,
    EVENT_IMG_AFREECATV: `${protocol}//event.img.${SERVICE_ROOT_DOMAIN}`,
    SPORTS_IMG_AFREECATV: `${protocol}//sports.img.${SERVICE_ROOT_DOMAIN}`,
    BBS_IMG_AFREECATV: `${protocol}//bbs.img.${SERVICE_ROOT_DOMAIN}`,
    FFOM_IMG_AFREECATV: `${protocol}//ffom.img.${SERVICE_ROOT_DOMAIN}`,
    VR_IMG_AFREECATV: `${protocol}//vr.img.${SERVICE_ROOT_DOMAIN}`,
    PROFILE_IMG_AFREECATV: `${protocol}//profile.img.${SERVICE_ROOT_DOMAIN}`,
    ADMIN_AFREECATV: `${protocol}//admin.${SERVICE_ROOT_DOMAIN}`,
    M_AFREECATV: `${protocol}//m.${SERVICE_ROOT_DOMAIN}`,
    API_M_AFREECATV: `${protocol}//api.m.${SERVICE_ROOT_DOMAIN}`,
    STATIC_M_AFREECATV: `${protocol}//static.m.${SERVICE_ROOT_DOMAIN}`,
    CACHE_M_AFREECATV: `${protocol}//cache.m.${SERVICE_ROOT_DOMAIN}`,
    ITEM_M_AFREECATV: `https://item.m.${SERVICE_ROOT_DOMAIN}`,
    AUTH_M_AFREECATV: `https://auth.m.${SERVICE_ROOT_DOMAIN}`,
    MEMBER_M_AFREECATV: `https://member.m.${SERVICE_ROOT_DOMAIN}`,
    WWW_AFREECATV: `${protocol}//www.${SERVICE_ROOT_DOMAIN}`,
    SPORTSTV_AFREECATV: `${protocol}//sportstv.${SERVICE_ROOT_DOMAIN}`,
    LIVE_AFREECATV: `${protocol}//live.${SERVICE_ROOT_DOMAIN}`,
    AFWBBS1_AFREECATV: `${protocol}//afwbbs1.${SERVICE_ROOT_DOMAIN}`,
    BJ_AFREECATV: `${protocol}//www.${SERVICE_ROOT_DOMAIN}/station`,
    OPENTV_AFREECATV: `${protocol}//opentv.${SERVICE_ROOT_DOMAIN}`,
    POINT_AFREECATV: `https://point.${SERVICE_ROOT_DOMAIN}`,
    POINTAPI_AFREECATV: `${protocol}//pointapi.${SERVICE_ROOT_DOMAIN}`,
    HELP_AFREECATV: `${protocol}//www.${SERVICE_ROOT_DOMAIN}/help`,
    HELP_API_AFREECATV: `${protocol}//help.${SERVICE_ROOT_DOMAIN}`,
    GHELP_AFREECATV: `${protocol}//ghelp.${SERVICE_ROOT_DOMAIN}`,
    APIHELP_AFREECATV: `${protocol}//apihelp.${SERVICE_ROOT_DOMAIN}`,
    ST_AFREECATV: `${protocol}//st.${SERVICE_ROOT_DOMAIN}`,
    STBBS_AFREECATV: `${protocol}//stbbs.${SERVICE_ROOT_DOMAIN}`,
    AFEVENT_AFREECATV: `${protocol}//afevent.${SERVICE_ROOT_DOMAIN}`,
    AFEVENT2_AFREECATV: `${protocol}//afevent2.${SERVICE_ROOT_DOMAIN}`,
    LOGIN_AFREECATV: `https://login.${SERVICE_ROOT_DOMAIN}`,
    AFUPD1_AFREECATV: `${protocol}//afupd1.${SERVICE_ROOT_DOMAIN}`,
    AFUPDJP_AFREECATV: `${protocol}//afupdjp.${SERVICE_ROOT_DOMAIN}`,
    MEMBER_AFREECATV: `https://member.${SERVICE_ROOT_DOMAIN}`,
    NOTE_AFREECATV: `${protocol}//note.${SERVICE_ROOT_DOMAIN}`,
    UPDATE_AFREECATV: `${protocol}//update.${SERVICE_ROOT_DOMAIN}`,
    PLAY_AFREECATV: `${protocol}//play.${SERVICE_ROOT_DOMAIN}`,
    ADREVENUE_AFREECATV: `${protocol}//adrevenue.${SERVICE_ROOT_DOMAIN}`,
    APISABANA_AFREECATV: `https://apisabana.${SERVICE_ROOT_DOMAIN}`,
    AFJOBENC1_AFREECATV: `${protocol}//afjobenc1.${SERVICE_ROOT_DOMAIN}`,
    SPORTS_AFREECATV: `${protocol}//sports.${SERVICE_ROOT_DOMAIN}`,
    SBS_AFREECATV: `${protocol}//sbs.${SERVICE_ROOT_DOMAIN}`,
    API_SPORTS_AFREECATV: `${protocol}//api.sports.${SERVICE_ROOT_DOMAIN}`,
    VR_AFREECATV: `${protocol}//vr.${SERVICE_ROOT_DOMAIN}`,
    ANI_AFREECATV: `${protocol}//ani.${SERVICE_ROOT_DOMAIN}`,
    TV_AFREECATV: `${protocol}//tv.${SERVICE_ROOT_DOMAIN}`,
    STAR_AFREECATV: `${protocol}//star.${SERVICE_ROOT_DOMAIN}`,
    ANALYSIS_AFREECATV: `${protocol}//analysis.${SERVICE_ROOT_DOMAIN}`,
    FFOM_AFREECATV: `${protocol}//ffom.${SERVICE_ROOT_DOMAIN}`,
    SHOP_AFREECATV: `${protocol}//sooptore.${SERVICE_ROOT_DOMAIN}`,
    SHOPFREECA_AFREECATV: `${protocol}//sooptore.${SERVICE_ROOT_DOMAIN}`,
    ADTIME_AFREECATV: `${protocol}//adtime.${SERVICE_ROOT_DOMAIN}`,
    ADBALLOON_AFREECATV: `${protocol}//adballoon.${SERVICE_ROOT_DOMAIN}`,
    UP_AFREECATV: `${protocol}//up.${SERVICE_ROOT_DOMAIN}`,
    ITEM_AFREECATV: `${protocol}//item.${SERVICE_ROOT_DOMAIN}`,
    TOKEN_AFREECATV: `${protocol}//token.${SERVICE_ROOT_DOMAIN}`,
    ITEMS_AFREECATV: `${protocol}//items.${SERVICE_ROOT_DOMAIN}`,
    INFODESK_AFREECATV: `${protocol}//infodesk.${SERVICE_ROOT_DOMAIN}`,
    BJGUIDE_AFREECATV: `${protocol}//bjguide.${SERVICE_ROOT_DOMAIN}`,
    DASHBOARD_AFREECATV: `${protocol}//dashboard.${SERVICE_ROOT_DOMAIN}`,
    SUBS_AFREECATV: `${protocol}//subs.${SERVICE_ROOT_DOMAIN}`,
    NEWBJ_AFREECATV: `${protocol}//newbj.${SERVICE_ROOT_DOMAIN}`,
    FREECAP_AFREECATV: `${protocol}//apro.${SERVICE_ROOT_DOMAIN}`,
    STATIC_FREECAP_AFREECATV: `${protocol}//static.apro.${SERVICE_ROOT_DOMAIN}`,
    BBS_FREECAP_AFREECATV: `${protocol}//bbs.apro.${SERVICE_ROOT_DOMAIN}`,
    GAMECENTERPC_AFREECATV: `${protocol}//gamecenterpc.${SERVICE_ROOT_DOMAIN}`,
    CONTENTLAB_AFREECATV: `${protocol}//contentlab.${SERVICE_ROOT_DOMAIN}`,
    WWW_BIZAFREECATV: `${protocol}//www.bizafreeca.com`,
    GAMETV_AFREECATV: `${protocol}//esports.${SERVICE_ROOT_DOMAIN}`,
    BORA_AFREECATV: `${protocol}//bora.${SERVICE_ROOT_DOMAIN}`,
    BESTBJ_AFREECATV: `${protocol}//bestbj.${SERVICE_ROOT_DOMAIN}`,
    ISSUE_AFREECATV: `${protocol}//issue.${SERVICE_ROOT_DOMAIN}`,
    AD_AFREECATV: `${protocol}//ad.${SERVICE_ROOT_DOMAIN}`,
    PA_AFREECATV: `${protocol}//pa.${SERVICE_ROOT_DOMAIN}`,
    VOD_AFREECATV: `${protocol}//vod.${SERVICE_ROOT_DOMAIN}`,
    VIDEO_AFREECATV: `${protocol}//video.${SERVICE_ROOT_DOMAIN}`,
    HLS_AFREECATV: `${protocol}//hls.${SERVICE_ROOT_DOMAIN}`,
    HLS_STAGE_AFREECATV: `${protocol}//hls-stage.${SERVICE_ROOT_DOMAIN}`,
    VIDEOIMG_AFREECATV: `${protocol}//videoimg.${SERVICE_ROOT_DOMAIN}`,
    VIDEOIMG_TEST_AFREECATV: `${protocol}//videoimg-test.${SERVICE_ROOT_DOMAIN}`,
    TS_PC_STREAM_AFREECATV: `${protocol}//ts-pc.stream.${SERVICE_ROOT_DOMAIN}`,
    AFREECATV_ASYNC_WISEN_GSCDN: `${protocol}//afreecatv.async.wisen.gscdn.com`,
    AFFLV_AFREECATV: `${protocol}//afflv14.${SERVICE_ROOT_DOMAIN}`,
    AQUA_AFREECATV: `${protocol}//aqua.${SERVICE_ROOT_DOMAIN}`,
    BROADSTATISTIC_AFREECATV: `${protocol}//broadstatistic.${SERVICE_ROOT_DOMAIN}`,
    SCH_AFREECATV: `${protocol}//sch.${SERVICE_ROOT_DOMAIN}`,
    SCKETC_AFREECATV: `${protocol}//scketc.${SERVICE_ROOT_DOMAIN}`,
    V_AFREE_CA: 'https://v.afree.ca',
    TRANSCODER_AFREECATV: `${protocol}//transcoder.${SERVICE_ROOT_DOMAIN}`,
    VACSDRDB_AFREECATV: `${protocol}//vacsdrdb.${SERVICE_ROOT_DOMAIN}`,
    EVENTAPI_AFREECATV: `${protocol}//eventapi.${SERVICE_ROOT_DOMAIN}`,
    API_UP_AFREECATV: `${protocol}//api.up.${SERVICE_ROOT_DOMAIN}`,
    STUDIO_AFREECATV: `${protocol}//studio.${SERVICE_ROOT_DOMAIN}`,
    SOTONG_AFREECATV: `${protocol}//sotong.${SERVICE_ROOT_DOMAIN}`,
    NEWAPPLY_AFREECATV: `${protocol}//newapply.${SERVICE_ROOT_DOMAIN}`,
    MYPOINT_AFREECATV: `${protocol}//mypoint.${SERVICE_ROOT_DOMAIN}`,
    VEDITOR_AFREECATV: `${protocol}//veditor.${SERVICE_ROOT_DOMAIN}`,
    DEVELOPERS_AFREECATV: `${protocol}//developers.${SERVICE_ROOT_DOMAIN}`,
    MYREVENUE_AFREECATV: `${protocol}//myrevenue.${SERVICE_ROOT_DOMAIN}`,
    OGQ_MARKET_AFREECATV: `${protocol}//ogqmarket.${SERVICE_ROOT_DOMAIN}`,
    OGQ_IMG_AFREECATV: `${protocol}//ogq-sticker-global-cdn-z01.${SERVICE_ROOT_DOMAIN}`,
    OGQ_IMG_TEST_AFREECATV: `${protocol}//ogqmarket.img.${SERVICE_ROOT_DOMAIN}`,
    ESPORTS_AFREECATV: `${protocol}//esports.${SERVICE_ROOT_DOMAIN}`,
    AFREECACOLOSSEUM: `${protocol}//www.afreecacolosseum.com`,
    MY_AFREECATV: `${protocol}//my.${SERVICE_ROOT_DOMAIN}`,
    PPV_AFREECATV: `${protocol}//ppv.${SERVICE_ROOT_DOMAIN}`,
    DDUKBOB_AFREECATV: `${protocol}//suggest.${SERVICE_ROOT_DOMAIN}`,
    TOKENAPI_AFREECATV: `https://tokenapi.${SERVICE_ROOT_DOMAIN}`,
    ADPAPI_AFREECATV: `${protocol}//adpapi.${SERVICE_ROOT_DOMAIN}`,
    OLYMPIC_AFREECATV: `${protocol}//olympic.${SERVICE_ROOT_DOMAIN}`,
    BJ_MATCH_AFREECATV: `${protocol}//bjmatch.${SERVICE_ROOT_DOMAIN}`,
    VODBJ_AFREECATV: `${protocol}//vodbj.${SERVICE_ROOT_DOMAIN}`,
    BJ_EDU_AFREECATV: `${protocol}//bjedu.${SERVICE_ROOT_DOMAIN}`,
    THEATER_AFREECATV: `${protocol}//theater.${SERVICE_ROOT_DOMAIN}`,
    AFTMARKET_TV: `${protocol}//aftmarket.tv`,
    EXTENSION_AFREECATV: `${protocol}//extension.${SERVICE_ROOT_DOMAIN}`,
    EXTENSION_FILE_AFREECATV: `${protocol}//extfileupload.${SERVICE_ROOT_DOMAIN}`,
    NOTI_AFREECATV: `${protocol}//noti.${SERVICE_ROOT_DOMAIN}`,
    GEM_ADMIN_AFREECATV: `https://esadmin.${SERVICE_ROOT_DOMAIN}`,
    GEM_API_AFREECATV: `${protocol}//gpapi.${SERVICE_ROOT_DOMAIN}`,
    PARTNERSHIP_AFREECATV: `${protocol}//partnership.${SERVICE_ROOT_DOMAIN}`,
    CREATOR_UP_AFREECATV: `${protocol}//creatorup.${SERVICE_ROOT_DOMAIN}`,
    ITEM_API_AFREECATV: `${protocol}//item-api.${SERVICE_ROOT_DOMAIN}`,
    ITEM_API_TEST_AFREECATV: `${protocol}//item-api-test.${SERVICE_ROOT_DOMAIN}`,
    ITEM_ADMIN_AFREECATV: `https://item-admin.${SERVICE_ROOT_DOMAIN}:8001`,
    ITEM_ADMIN_TEST_AFREECATV: `https://item-admin-test.${SERVICE_ROOT_DOMAIN}:8001`,
    DOLRIMPAN_AFREECATV: `${protocol}//dolrimpan.${SERVICE_ROOT_DOMAIN}`,
    BILLIARDS_AFREECATV: `${protocol}//billiards.${SERVICE_ROOT_DOMAIN}`,
    CINETY_AFREECATV: `${protocol}//cinety.${SERVICE_ROOT_DOMAIN}`,
    DEAPI_AD_AFREECATV: `${protocol}//deapi.${SERVICE_ROOT_DOMAIN}`,
    DEAPIDEV_AD_AFREECATV: `${protocol}//deapidev.${SERVICE_ROOT_DOMAIN}`,
    SAYBUZZ_AD_URL: `${protocol}//ad.saybuzz.io`,
    SAYBUZZ_ITEM_URL: `${protocol}//item.saybuzz.io`,
    SAYBUZZ_URL: `${protocol}//www.saybuzz.io`,
    SAYBUZZ_ABOUT_URL: `${protocol}//about.saybuzz.io`,
    AWARD_AFREECATV: `${protocol}//award.${SERVICE_ROOT_DOMAIN}`,
    ADV_AFREECATV: `${protocol}//adv.${SERVICE_ROOT_DOMAIN}`,
    SPORTSISSUE_AFREECATV: `https://sportsissue.${SERVICE_ROOT_DOMAIN}`,
    STARRANK_AFREECATV: `https://starrank.${SERVICE_ROOT_DOMAIN}`,
    CORP_AFREECATV: `https://corp.${SERVICE_ROOT_DOMAIN}`,
    RECRUIT_AFREECATV: `https://recruit.${SERVICE_ROOT_DOMAIN}`,
    FORM_AFREECATV: `${protocol}//form.${SERVICE_ROOT_DOMAIN}`,
    OPENAPI_AFREECATV: `${protocol}//openapi.${SERVICE_ROOT_DOMAIN}`,
    TKAPI_AFREECATV: `${protocol}//tkapi.${SERVICE_ROOT_DOMAIN}`,
    AUTOPAY_FREE_AFREECATV: `${protocol}//autopay-free.${SERVICE_ROOT_DOMAIN}`,
    ATVAPI_AFREECATV: `${protocol}//atvapi.${SERVICE_ROOT_DOMAIN}`,
    GFL_AFREECATV: `${protocol}//gfl.${SERVICE_ROOT_DOMAIN}`,
    LINK_AFREECATV: `https://link.${SERVICE_ROOT_DOMAIN}`,
    ENTRYSTATIC_AFREECATV: `https://entrystatic.${SERVICE_ROOT_DOMAIN}`,
    BJAPI_AFREECATV: `https://chapi.${SERVICE_ROOT_DOMAIN}`,
    SHOP_IMG_AFREECATV: `https://shop.img.${SERVICE_ROOT_DOMAIN}`,
    SLUGGER_AFREECATV: `https://slugger.${SERVICE_ROOT_DOMAIN}`,
    GAMERANKING_AFREECATV: `https://gameranking.${SERVICE_ROOT_DOMAIN}`,
    GEM_AFREECATV: `${protocol}//gem.${SERVICE_ROOT_DOMAIN}`,
    PARTNERBJ_AFREECATV: `${protocol}//partnerbj.${SERVICE_ROOT_DOMAIN}`,
    SUPPORTERS_AFREECATV: `${protocol}//supporters.${SERVICE_ROOT_DOMAIN}`,
    VOTE_AFREECATV: `${protocol}//vote.${SERVICE_ROOT_DOMAIN}`,
    MYAPI_AFREECATV: `${protocol}//myapi.${SERVICE_ROOT_DOMAIN}`,
    STS_FREECAP_AFREECATV: `${protocol}//cappy.${SERVICE_ROOT_DOMAIN}`,
    GGGL_API_AFREECATV: `${protocol}//ggglapi.${SERVICE_ROOT_DOMAIN}`,
    EXTENSION_DEPLOY_UPLOAD_AFREECATV: `${protocol}//file.ext-${SERVICE_ROOT_DOMAIN}`,
    DROPS_AFREECATV: `${protocol}//drops.${SERVICE_ROOT_DOMAIN}`,
    SOOPI_AFREECATV: `${protocol}//soopi.${SERVICE_ROOT_DOMAIN}`,
    SOOPI_API_AFREECATV: `${protocol}//soopi-api.${SERVICE_ROOT_DOMAIN}`,
    SAVVY_API_AFREECATV: `${protocol}//savvy-api.${SERVICE_ROOT_DOMAIN}`,
    OVERLAY_AFREECATV: `${protocol}//dashboard.${SERVICE_ROOT_DOMAIN}/overlay`,
    SOOP_AI_API_AFREECATV: `${protocol}//soop-ai-api.${SERVICE_ROOT_DOMAIN}`,
    DEV_SOOP_AI_API_AFREECATV: `${protocol}//dev-soop-ai-api.${SERVICE_ROOT_DOMAIN}` // 개발 soop ai api
  };
};
const developmentDomain = (protocol, hostname) => ({
  ...commonDomains(protocol, hostname)
});
const productionDomain = (protocol, hostname) => ({
  ...commonDomains(protocol, hostname)
});

const scheme = {
  AFREECATV_APP_SCHEME: 'afreeca://',
  SOOPLIVE_APP_SCHEME: 'sooplive://',
  SERVICE_APP_SCHEME: 'sooplive://'
};

export { agent, cookie, hostGenerator, scheme };
//# sourceMappingURL=index.js.map
